<div id="titulo">
    <h2>Insertar comentario</h2>
    <span style="flex: 1 1 auto;"></span>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
</div>
<div style="padding: 20px;">
    <div style="display: flex;gap: 10px;margin-top:20px; width:99%;">
        <div class="campo">
            <label>Introduzca un comentario nuevo</label>
            <input matInput  [(ngModel)]="comentarioNuevo.obser" >
        </div>
    </div>
</div>
<div id="containerBtn">
    <a class="btnCCOscuro" mat-flat-button (click)="onClose()">Cancelar</a>
    <a class="btnCCNewOscuro"  mat-flat-button (click)="agregarComentario()">Aceptar</a>
</div>
